import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_DM_WITH_LEGISLATIVE_BODIES_CONNECTION_ENABLED = createFcmDetails(
	'dm_with_legislative_bodies_connection_enabled',
	{
		owner: 'Capybara',
		context:
			'Allows consumer (e.g. petition page DM section) to use alternative dmConnection query to fetch DMs with legislative bodies formatting',
		description: 'Country+locale on/off switch',
		import: false,
		mergeLogic: 'Uses a combined country & locale value if either is set, otherwise global value is used',
	},
);
